<script setup lang="ts">
import { computed } from 'vue';
import InputText from 'primevue/inputtext';
import InputTextAera from 'primevue/textarea';

interface Props {
  inputValue: object;
  validate: any;
}
const props = defineProps<Props>();

const emits = defineEmits<{ 'update:inputValue': [value: any] }>();

const inputValue = computed({
  get() {
    return props.inputValue;
  },
  set(value) {
    emits('update:inputValue', value);
  }
});
</script>
<template>
  <div class="tour-info-en">
    <div class="mb-3">
      <label for="tour_name_en" class="font-title">{{ $t('management.tour.tour_name_en') }} <span class="text-primary">*</span></label>
      <InputText id="tour_name_en" :class="validate.tourNameEn?.$error ? 'p-invalid w-full' : 'w-full'" type="text" v-model="inputValue.tourNameEn" />
      <p class="text-red-500 pt-1" v-if="validate.tourNameEn?.$error">{{ $t('validate.required') }}</p>
    </div>
    <div class="mb-3">
      <label for="tour_inclusions_en" class="flex justify-content-between font-title">
        <div>{{ $t('management.tour.tour_inclusions_en') }} <span class="text-primary">*</span></div>
        <i class="pi pi-info-circle mt-1" style="color: blue" v-tooltip="$t('management.tour.guide_inclusion')"></i>
      </label>
      <InputText id="tour_inclusions_en" :class="validate.tourInclusionEn?.$error ? 'p-invalid w-full' : 'w-full'" type="text" v-model="inputValue.tourInclusionEn" />
      <p class="text-red-500 pt-1" v-if="validate.tourInclusionEn?.$error">{{ $t('validate.required') }}</p>
    </div>
    <div class="mb-3">
      <label for="tour_details_link_en" class="flex justify-content-between font-title">
        <div>{{ $t('management.tour.tour_details_link_en') }} <span class="text-primary">*</span></div>
        <i class="pi pi-info-circle mt-1" style="color: blue" v-tooltip="$t('management.tour.guide_details_link')"></i>
      </label>
      <InputText id="tour_details_link_en" :class="validate.tourLinkEn?.$error ? 'p-invalid w-full' : 'w-full'" type="text" v-model="inputValue.tourLinkEn" />
      <p class="text-red-500 pt-1" v-if="validate.tourLinkEn?.$error">{{ $t('validate.required') }}</p>
    </div>
    <div class="mb-3">
      <label for="visited_cities_en" class="flex justify-content-between font-title">
        <div>{{ $t('management.tour.visited_cities_en') }} <span class="text-primary">*</span></div>
        <i class="pi pi-info-circle mt-1" style="color: blue" v-tooltip="$t('management.tour.guide_visited_cities')"></i>
      </label>
      <InputText id="visited_cities_en" :class="validate.visitedCitiesEn?.$error ? 'p-invalid w-full' : 'w-full'" type="text" v-model="inputValue.visitedCitiesEn" />
      <p class="text-red-500 pt-1" v-if="validate.visitedCitiesEn?.$error">{{ $t('validate.required') }}</p>
    </div>
    <div class="mb-3">
      <label for="tour_description_en" class="flex justify-content-between font-title">
        <div>{{ $t('management.tour.tour_description_en') }} <span class="text-primary">*</span></div>
        <i class="pi pi-info-circle mt-1" style="color: blue" v-tooltip="$t('management.tour.guide_description')"></i>
      </label>
      <InputTextAera id="tour_description_en" rows="5" class="w-full tour_description_en" :class="validate.tourDescriptionEn?.$error ? 'p-invalid w-full' : 'w-full'" v-model="inputValue.tourDescriptionEn"></InputTextAera>
      <p class="text-red-500 pt-1" v-if="validate.tourDescriptionEn?.$error">{{ $t('validate.required') }}</p>
    </div>
  </div>
</template>
